export default __webpack_public_path__ + "static/media/Home-page3.35b7c8e6.png";